export default {"src":"/_next/static/media/tick.bea9f23c.svg","height":27,"width":28};